/* tslint:disable */
/* eslint-disable */
/**
 * Midcoast Water Bureau API
 * Backend API documentation for Midcoast Water Bureau application. This API provides endpoints for user management, device monitoring, water meter measurements, and notification systems.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: support@nucleus3.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CustomErrorResponse } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { DevicePropertyProfileRequest } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { DevicesResponse } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { Item } from '../n3-backend-open-api-gen/model';
/**
 * DeviceApi - axios parameter creator
 */
export const DeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves metadata for a specific device using its unique system identifier. Includes serial number, brand, and meter type information.
         * @summary Get single device details
         * @param {number} id The internal database ID of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDevice', 'id', id)
            const localVarPath = `/api/v1/devices/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all water meters and devices currently associated with the authenticated user profile.
         * @summary List all user-owned devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/devices/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a property profile declaration for an already linked device assigned to the authenticated user.
         * @summary Set current user\'s property profile for a linked device
         * @param {number} id The internal database ID of the device
         * @param {DevicePropertyProfileRequest} devicePropertyProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevicePropertyProfile: async (id: number, devicePropertyProfileRequest: DevicePropertyProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDevicePropertyProfile', 'id', id)
            // verify required parameter 'devicePropertyProfileRequest' is not null or undefined
            assertParamExists('updateDevicePropertyProfile', 'devicePropertyProfileRequest', devicePropertyProfileRequest)
            const localVarPath = `/api/v1/devices/{id}/property-profile`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(devicePropertyProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceApi - functional programming interface
 */
export const DeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves metadata for a specific device using its unique system identifier. Includes serial number, brand, and meter type information.
         * @summary Get single device details
         * @param {number} id The internal database ID of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevice(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Item>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.getDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of all water meters and devices currently associated with the authenticated user profile.
         * @summary List all user-owned devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.getDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a property profile declaration for an already linked device assigned to the authenticated user.
         * @summary Set current user\'s property profile for a linked device
         * @param {number} id The internal database ID of the device
         * @param {DevicePropertyProfileRequest} devicePropertyProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevicePropertyProfile(id: number, devicePropertyProfileRequest: DevicePropertyProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevicePropertyProfile(id, devicePropertyProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.updateDevicePropertyProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceApi - factory interface
 */
export const DeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceApiFp(configuration)
    return {
        /**
         * Retrieves metadata for a specific device using its unique system identifier. Includes serial number, brand, and meter type information.
         * @summary Get single device details
         * @param {number} id The internal database ID of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Item> {
            return localVarFp.getDevice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of all water meters and devices currently associated with the authenticated user profile.
         * @summary List all user-owned devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices(options?: RawAxiosRequestConfig): AxiosPromise<DevicesResponse> {
            return localVarFp.getDevices(options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a property profile declaration for an already linked device assigned to the authenticated user.
         * @summary Set current user\'s property profile for a linked device
         * @param {number} id The internal database ID of the device
         * @param {DevicePropertyProfileRequest} devicePropertyProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevicePropertyProfile(id: number, devicePropertyProfileRequest: DevicePropertyProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDevicePropertyProfile(id, devicePropertyProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceApi - object-oriented interface
 */
export class DeviceApi extends BaseAPI {
    /**
     * Retrieves metadata for a specific device using its unique system identifier. Includes serial number, brand, and meter type information.
     * @summary Get single device details
     * @param {number} id The internal database ID of the device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDevice(id: number, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).getDevice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of all water meters and devices currently associated with the authenticated user profile.
     * @summary List all user-owned devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDevices(options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).getDevices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a property profile declaration for an already linked device assigned to the authenticated user.
     * @summary Set current user\'s property profile for a linked device
     * @param {number} id The internal database ID of the device
     * @param {DevicePropertyProfileRequest} devicePropertyProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDevicePropertyProfile(id: number, devicePropertyProfileRequest: DevicePropertyProfileRequest, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).updateDevicePropertyProfile(id, devicePropertyProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

